import { type FC } from "react";
import { Link } from "react-router-dom";
import { styled, Typography } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { FormattedMessage } from "react-intl";

const StyledLink = styled(Link)(({ theme }) => ({
	color: theme.palette.primary.main,
	marginLeft: "auto",
	display: "flex",
	alignItems: "center",
	gap: theme.spacing(0.5),
	textDecoration: "none",
	"&:hover": {
		color: theme.palette.primary.dark,
	},
}));

export const HistoryLink: FC = () => {
	return (
		<StyledLink to="history">
			<HistoryIcon fontSize="small" />
			<Typography variant="body2">
				<FormattedMessage id="History" defaultMessage="History" />
			</Typography>
		</StyledLink>
	);
};
